let hidden, visibilityChange;
if (typeof document.hidden !== 'undefined') {
	// Opera 12.10 and Firefox 18 and later support
	hidden = 'hidden';
	visibilityChange = 'visibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
	hidden = 'msHidden';
	visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
	hidden = 'webkitHidden';
	visibilityChange = 'webkitvisibilitychange';
}
export const keyHiddenEvent = hidden;
export const addHiddenEventListener = (callback) => {
	// Handle page visibility change
	document.addEventListener(visibilityChange, callback, false);
};

export const removeHiddenEventListener = (callback) => {
	document.removeEventListener(visibilityChange, callback, false);
};
